import React from "react";
import MultiSelectDropdown from "app/components/MultiSelectDropdown";
import DropdownButton from "app/containers/Features/containers/Home/components/TicketFilters/DropdownButton";
import clsx from "clsx";
import StatusIcon from "app/components/Icons/StatusIcon";

import { FilterOption } from "app/containers/Features/containers/Home/type";

interface Props {
  selectedIds: string[];
  onUpdate: (values: string[]) => void;
  options: FilterOption[];
  disabled?: boolean;
}

const StatusFilter: React.FC<Props> = ({ selectedIds, onUpdate, options, disabled }) => {
  const isAllSelected = options.length > 0 && selectedIds.length === options.length;
  const selectedNames = selectedIds.map(
    (id) => options.find((o) => o.id === id)?.value || id,
  );

  return (
    <div className="relative">
      <MultiSelectDropdown
        title="Status"
        options={options}
        selectedOptions={selectedIds}
        setSelectedOptions={onUpdate}
        searchPlaceholder="Search Status"
        trigger={
          <button
            disabled={disabled}
            className={clsx(
              "text-sm font-normal text-primary h-[32px] max-w-[400px] min-w-[157px] flex flex-row items-center justify-between gap-[6px]  bg-white border rounded-[54px] px-[10px] text-ellipsis whitespace-nowrap overflow-hidden outline-none disabled:opacity-50 disabled:pointer-events-none",
              isAllSelected || selectedIds.length
                ? "border-primary"
                : "border-secondary",
            )}
          >
            <DropdownButton
              icon={<StatusIcon size={14} />}
              isAllSelected={isAllSelected}
              selectedItems={selectedIds}
              selectedItemNames={selectedNames}
              title="Status:"
            />
          </button>
        }
      />
    </div>
  );
};

export default StatusFilter;
